module.exports = __webpack_public_path__ + "static/img/1.57fbad5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/zh/1.png
// module id = STcE
// module chunks = 0